<template>
  <div>
    <form @submit.prevent="saveMenuItem">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="md"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <span class="pl-2">
            {{ input ? "Edit" : "Add" }} Variant Category
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row class="mt-2">
              <b-col md="3">
                <label>Name</label>
              </b-col>
              <b-col md="7">
                <b-form-input
                  v-model="obj.name"
                  v-validate="'required|alpha_num'"
                  type="text"
                  name="name"
                />
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success">
            {{ input ? "Update" : "Save" }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import _ from 'lodash';
import constants from '@/utils/constants';
export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: {}
    };
  },

  mounted() {},

  methods: {
    saveMenuItem() {
      if (!this.obj.name) {
        return this.$swal(
          constants.SOMETHING_WROING,
          'Name should not be empty',
          constants.STATUS_ERROR
        );
      }
      try {
        if (this.input === null) {
          this.$store.dispatch('CreateCategoryItem', this.obj).then(res => {
            if (res.data.message === constants.STATUS_OK_UPPER) {
              this.$emit('discard-modal', true);
              this.$swal(
                constants.SUCCESS_MESSAGE,
                'Category Created',
                constants.STATUS_SUCCESS
              );
              this.reset();
            } else {
              this.$swal(
                constants.SOMETHING_WROING,
                res.invalidMessage,
                constants.STATUS_ERROR
              );
            }
          });
        } else {
          this.$store.dispatch('UpdateCategoryItem', this.obj).then(res => {
            if (res.data.message === constants.STATUS_OK_UPPER) {
              this.$emit('discard-modal', true);
              this.$swal(
                constants.SUCCESS_MESSAGE,
                'Category Created',
                constants.STATUS_SUCCESS
              );
              this.reset();
            } else {
              this.$swal(
                constants.SOMETHING_WROING,
                res.invalidMessage,
                constants.STATUS_ERROR
              );
            }
          });
        }
      } catch {
        this.$swal(constants.SOMETHING_WROING, '', constants.STATUS_ERROR);
      }
    },

    discardModal() {
      this.reset();
      this.$emit('discard-modal');
    },

    // reset input fields
    reset() {
      if (this.input == null) {
        this.obj = {
          name: '',
          id: ''
        };
      } else {
        this.obj = this.input;
      }
    }
  }
};
</script>
